/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Layout as AntDLayout } from 'antd';

const { Footer: AntDFooter } = AntDLayout;

export type FooterProps = {
  className?: string;
  children: React.ReactNode;
};

export function Footer({ children, className }: FooterProps) {
  return (
    <AntDFooter className={className} style={{ marginTop: 'auto', flexShrink: 0 }}>
      {children}
    </AntDFooter>
  );
}
